import { render, staticRenderFns } from "./FormRFSusar.vue?vue&type=template&id=148ddf6d"
import script from "./FormRFSusar.vue?vue&type=script&lang=js"
export * from "./FormRFSusar.vue?vue&type=script&lang=js"
import style0 from "./FormRFSusar.vue?vue&type=style&index=0&id=148ddf6d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports